import React, { useState } from 'react';
import './ShortMenuBar.scss';
import { useLocation, useNavigate } from 'react-router';
import Sidebar from 'componentsV2/SideBar/SideBar';
import { BASE_URL } from 'constants/routes';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { useDispatch } from 'react-redux';
import { searchActions } from 'actions/search';
interface Link {
  path: string;
  pathName: string;
}

interface ShortMenuBarProps {
  searchRef: React.RefObject<HTMLCoreSearchElement>;
}

const ShortMenuBar: React.FC<ShortMenuBarProps> = ({ searchRef }) => {
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  
  const [isShowSidebar, setIsShowSidebar] = useState(false);
  const location = useLocation().pathname.split('/admin/digitalassets/')[1]; // Get the current path without the leading slash
  console.log('Current location:', location);
  const navigatePath = (path: string) => {
    const formattedPath = path.split(' ').join('-').toLowerCase();
    navigate(`${BASE_URL}/${formattedPath}`);
    window.scrollTo(0, 0);
    if (searchRef?.current?.clearSearchText) {
      dispatch(searchActions.getSearchValues(''));
      searchRef.current.clearSearchText();
    }
  };
  const navigate = useNavigate();
  // Utility function to get the icon name based on the path
  const getIconName = (path: string): string => {
    const iconMappings: Record<string, string> = {
      home: 'icon-24-home-mono',
      'asset-upload': 'icon-24-upload-mono',
      jobs: 'icon-24-creditCard-mono'
    };
    return iconMappings[path] || '';
  };
  // Sidebar links
  const links: Link[] = [
    { path: 'home', pathName: 'Home' },
    { path: 'asset-upload', pathName: 'Asset Upload' },
    { path: 'jobs', pathName: 'Jobs' }
  ];
  // generate a side bar with icons add styling
  return (
    <div className="short-menu-bar">
      <div className="hamburger-icon" onClick={() => setIsShowSidebar(!!Sidebar)}>
        <span className="icon-32-hamburgerMenu-mono" title='Expand Side Bar'></span>
      </div>
      {links.map((link) => (
        <div
          title={link.pathName}
          key={link.path}
          className="menu-item"
          onClick={() => navigatePath(link.path)}
          data-testid={`menu-item-${link.path}`}>
          <span
            className={`${getIconName(link.path)} ${location === link.path ? 'active' : 'in-active'
            }`}></span>
        </div>
      ))}
      <div className="side-bar">
        <Sidebar
          isShowSidebar={isShowSidebar}
          setIsShowSidebar={setIsShowSidebar}
          searchRef={searchRef}
        />
      </div>
    </div>
  );
};

export default ShortMenuBar;
